export default "__VITE_ASSET__GTgVr9____"